import { AmountDTO } from '@/types/AmountDTO';
import { Grid } from '@mui/material';
import { PayCardButton } from '@/components/create/card/buttons/PayCardButton';
import React, { FC } from 'react';

interface Props {
  amounts?: AmountDTO[];
  setPayAmount: (payAmount: number) => void;
}

export const PayCardButtonGroup: FC<Props> = (props: Props) => {
  const { amounts, setPayAmount } = props;

  return (
    <Grid container={true} spacing={1} alignItems={'center'} sx={{ height: 'calc(100% + 8px)' }}>
      {(amounts || []).map((amount: AmountDTO) => (
        <Grid item={true} key={amount.id}>
          <PayCardButton payAmount={amount.value} setPayAmount={setPayAmount} />
        </Grid>
      ))}
    </Grid>
  );
};
